import { useQuery } from '@apollo/client'
import { SHOW_VIDEO_LIST, URL_VIDEO_PLAYING } from '../../../graphql-client/Queries'
import VideoCard from '../../home/home_right/videoCard/VideoCard'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

export default function PlayVideoList(props) {
    const { id } = useParams();
    const [currentTake, setCurrentTake] = useState(10);
    
    // Truy vấn video để lấy videoListId
    const {loading: loadingVideo, error: errorVideo, data: videoData} = useQuery(URL_VIDEO_PLAYING, {
        variables: {id},
        fetchPolicy: 'no-cache'
    });
    
    // Reset currentTake khi videoListId thay đổi
    useEffect(() => {
        setCurrentTake(10);
    }, [videoData?.video?.videoListId]);
    
    // Truy vấn danh sách video dựa trên videoListId
    const {loading, error, data, fetchMore, refetch}= useQuery(SHOW_VIDEO_LIST, {
        variables:{idVideoList: videoData?.video?.videoListId, take: currentTake},
        skip: !videoData?.video?.videoListId,
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
    });
    
    // Refetch khi videoListId thay đổi
    useEffect(() => {
        if (videoData?.video?.videoListId) {
            refetch({
                idVideoList: videoData.video.videoListId,
                take: 10
            });
        }
    }, [videoData?.video?.videoListId, refetch]);
    
    if(loadingVideo) return (
        <div className="card" aria-hidden="true">
            <div className="card-body">
                <h5 className="card-title placeholder-glow">
                    <span className="placeholder col-6" />
                </h5>
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7" />
                    <span className="placeholder col-4" />
                </p>
            </div>
        </div>
    );
    
    if (errorVideo) return <p>Error! {errorVideo.message}</p>;
    
    // Kiểm tra video có videoListId không
    if (!videoData?.video?.videoListId) {
        return null;
    }
    
    if (loading) return (
        <div className="card" aria-hidden="true">
            <div className="card-body">
                <h5 className="card-title placeholder-glow">
                    <span className="placeholder col-6" />
                </h5>
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7" />
                    <span className="placeholder col-4" />
                </p>
            </div>
        </div>
    );
    
    if (error) return <p>Error! {error.message}</p>; 
    
    // Kiểm tra có dữ liệu không
    if (!data?.showVideoList || data.showVideoList.length === 0) {
        return <p className='m-2'>Không có tài liệu nào trong khóa học này.</p>;
    }
    
    const onLoadMore = async () => {
        const newTake = currentTake + 5;
        setCurrentTake(newTake);
        
        await fetchMore({
            variables: {
                idVideoList: videoData.video.videoListId,
                take: newTake
            },
        });
    };
    
    const hasMore = data.showVideoList.length >= currentTake;
    
    return (
        <div className='listVideoAtWatching ms-2 ps-2'>
            <h5 className='m-1 p-1 sticky-header'>Tài liệu khác trong khóa học</h5>
            {data.showVideoList.map((video) => {                     
                return (                                  
                    <VideoCard
                        key={video.id}
                        title={video.title}
                        username={video.user.username}
                        date={video.createdAt}
                        view={video.countView}
                        like={video.countLike}
                        videoId={video.id}
                        thumbnail={video.thumbnail}
                        document={video.document}
                        avatarUser={video.user.avatar}
                        idUser={video.user.id}
                        nextVideo={true}
                    >
                    </VideoCard>
                )
            })}
            
            {hasMore && (
                <button 
                    className='btn btn-link ms-2' 
                    onClick={onLoadMore}
                >
                    <b>Xem thêm tài liệu</b>
                </button>
            )}
        </div>
    )
}